import React, { Component } from 'react';
import Chart from 'chart.js';
import styles from './circular-graph.module.scss';
import colors from '../../sass-utils/colors.module.scss';

export interface GraphProps {
  percentage: number;
  title: string;
  color?: string;
  icon?: string;
}

export class CircularGraph extends Component<GraphProps> {
  public chartEl = React.createRef<HTMLCanvasElement>();
  public backgroundChartEl = React.createRef<HTMLCanvasElement>();
  public ctx: CanvasRenderingContext2D | null = null;
  public backgroundCtx: CanvasRenderingContext2D | null = null;
  public color = this.props.color ? colors[this.props.color] : colors.brandPrimary;
  public chartOptions = {
    type: 'doughnut',
    data: {},
    options: {
      responsive: true,
      cutoutPercentage: 85,
      aspectRatio: 1,
      tooltips: {
        enabled: false,
      },
    },
  };

  public componentDidMount = () => {
    this.chartOptions.data = {
      datasets: [
        {
          data: [this.props.percentage, 100 - this.props.percentage],
          backgroundColor: [this.color, 'transparent'],
          hoverBackgroundColor: [this.color, 'transparent'],
          borderWidth: 0,
        },
      ],
    };

    setTimeout(() => {
      if (this.backgroundChartEl.current) {
        this.backgroundCtx = this.backgroundChartEl.current.getContext('2d');
        const backgroundChartOptions = { ...this.chartOptions };
        backgroundChartOptions.data = {
          datasets: [
            {
              data: [100],
              backgroundColor: [this.color],
              hoverBackgroundColor: [this.color],
              borderWidth: 0,
            },
          ],
        };
        new Chart(this.backgroundCtx as CanvasRenderingContext2D, backgroundChartOptions);
      }
    }, 500);

    setTimeout(() => {
      if (this.chartEl.current) {
        this.ctx = this.chartEl.current.getContext('2d');
        new Chart(this.ctx as CanvasRenderingContext2D, this.chartOptions);
      }
    }, 1000);
  };

  public render = () => {
    return (
      <div className={styles.container}>
        <div className={styles.graph}>
          <div className={styles.percentage}>{this.props.percentage}%</div>
          <canvas className={styles.backgroundCanvas} ref={this.backgroundChartEl} />
          <canvas className={styles.canvas} ref={this.chartEl} />
          {this.props.icon && (
            <div
              className={`${styles.icon} ${styles[this.props.icon] ? styles[this.props.icon] : ''}`}
              style={{ backgroundColor: this.color }}
            />
          )}
        </div>
        <h2 className={styles.graphTitle}>{this.props.title}</h2>
      </div>
    );
  };
}
